/**
 * Escapes a plain-text annotation into editor markup, one paragraph per line.
 * TipTap collapses raw newlines into a single line, so a legacy note must be
 * converted before it is handed to the editor; escaping keeps text that
 * happens to quote html (a student documenting a script tag) as visible text.
 * An empty line becomes an empty paragraph, which projects back to the blank
 * line on save, so the round trip preserves the original spacing.
 */
const escapeHtml = text => text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

export default function plainTextToEditorHtml(text) {
    if (!text) {
        return '';
    }

    return text
        .split('\n')
        .map(line => `<p>${escapeHtml(line)}</p>`)
        .join('');
}
